import styles from './ColorInput.module.css'
import { useState, useEffect, useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { BuilderContext } from '../../../../store/store.Builder'
import { ColorPicker, Button } from 'antd'

const ColorInput = observer(({ name, value, onChange }) => {
  const presetColors = [
    'transparent',
    '#000000',
    '#545454',
    '#737373',
    '#a6a6a6',
    '#d9d9d9',
    '#FFFFFF',
    '#ff3131',
    '#ff5757',
    '#ff66c4',
    '#cb6ce6',
    '#8cf2ff',
    '#5e17eb',
    '#0097b2',
    '#0cc0df',
    '#5ce1e6',
    '#38b6ff',
    '#5271ff',
    '#004aad',
    '#344767',
    '#00bf63',
    '#7ed957',
    '#2ed979',
    '#ffde59',
    '#ff914d',
  ]
  const builderContext = useContext(BuilderContext)

  const [colorHex, setColorHex] = useState(value || 'transparent')
  const [formatHex, setFormatHex] = useState('hex')

  useEffect(() => {
    setColorHex(value)
  }, [value])

  const handleColorChange = (color) => {
    const colorValue = color.toHexString ? color.toHexString() : color
    setColorHex(colorValue)
    console.log('VALEUR A CHANGE', colorValue)
    onChange({ target: { value: colorValue, name } })
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>Couleur active</div>
      <ColorPicker
        format={formatHex}
        value={colorHex}
        onChange={handleColorChange}
        onFormatChange={setFormatHex}
        className={styles.color_active}
      />
      <div className={styles.title}>Couleurs par défaut</div>
      <div className={styles.container__defaultcolors}>
        {presetColors.map((color) => (
          <Button
            className={
              color === 'transparent'
                ? `${styles.button} ${styles.buttonTransparent}`
                : styles.button
            }
            key={color}
            style={{ backgroundColor: color }}
            onClick={() => handleColorChange(color)}
          />
        ))}
      </div>
    </div>
  )
})

export default ColorInput
